import React from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import EditIcon from "../../svg/svgicon/EditIcon";
import DeleteIcon from "../../svg/svgicon/DeleteIcon";
import InviteIcon from "../../svg/svgicon/InviteIcon";
import "./MenuVertical.css";
const MenuVertical = (props) => {
  return (
    <div>
      <Menu onClick={props.onMenuChange}>
        {props.isadmin && props.istender && props.isedit ?
        <Menu.Item key={1}>
            <EditIcon /> Засах
        </Menu.Item>
        : props.iscopy ? 
        <Menu.Item key={1}>
            <EditIcon /> Хуулах    
        </Menu.Item>
        : null}
         {props.isadmin && props.isedit ?
        <Menu.Item key={2}>
            <DeleteIcon /> Устгах
        </Menu.Item> : null }
        {props.istender ? 
        <Menu.Item style={{ borderTop: "0.5px solid #DEDEDE" }} key={3}>
            <InviteIcon /> Урилга
        </Menu.Item>
        : null}
        {props.iswork ? 
        <Menu.Item style={{ borderTop: "0.5px solid #DEDEDE" }} key={4}>
            <InviteIcon /> ХА Урилга
        </Menu.Item>
        : null}
      </Menu>
    </div>
  );
};

export default MenuVertical;
